import { Event } from '../api/events/Event';

export function dispatchEvent(event: Event) {
    document.dispatchEvent(
        new CustomEvent<Event>(event.type, { detail: event })
    );
}
